export default {
    routeChange: false,
    showMenu: false,
    header_title: null,
    load_status: false,
}
